/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Página não encontrada",
  "ComingSoon": "Em breve",
  "YesanPersonalFinance": "Yesan, Finanças pessoais",
  "Yesan": "Yesan",
  "PersonalFinance": "Finanças pessoais",
  "YesanDownload": "Download do Yesan",
  "ThisWebsiteUsesCookies": "Usamos cookies para coletar e analisar informações sobre o desempenho e o uso do nosso site e para fornecer recursos de mídia social. Ao continuar, você concorda com nosso uso de cookies.",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Torne-se financeiramente livre",
  "inStepsAndActions": "em 8 etapas e 3 ações.",
  "TrackPlanAnalyze": "Acompanhe. Planeje. Analisar.",
  "FTrack": "1. Rastrear",
  "FPlan": "2. Planejar",
  "FAnalyze": "3. Analisar",
  "Features": "Recursos",
  "FeaturesSubHeading": "Se você é apenas um iniciante e já tem conhecimentos financeiros, este é o aplicativo de que você precisa para se tornar financeiramente livre.",
  "ManageAccounts": "Gerenciar contas",
  "CashLiquidFixedAssetsLiabilities": "Dinheiro, líquido, ativos fixos e passivos.",
  "TrackTransactions": "Acompanhe as transações",
  "IncomesExpensesTransferInvestments": "Receitas, despesas, transferências e investimentos.",
  "ImportExport": "Importação/exportação",
  "YourDataAlwaysAccessible": "Seus dados sempre acessíveis.",
  "PlanYourFreedom": "Planeje sua liberdade",
  "StepsAwayFromFI": "A 8 passos da independência financeira.",
  "BudgetsAndGoals": "Orçamentos e metas",
  "CheckYourProgressAndAchieve": "Verifique seu progresso e atinja suas metas financeiras.",
  "DashboardAndAnalytics": "Dashboard & Analytics",
  "ReviewLearnOptimizeWith": "Analise, aprenda e otimize com gráficos, insights e ferramentas.",
  "Security": "Segurança",
  "MilitaryGradeEncryption": "Criptografia de nível militar, suporte a biometria, dados armazenados em seus dispositivos.",
  "OfflineMode": "Modo off-line",
  "YourDataAlwaysAccessibleAndModif": "Seus dados sempre acessíveis e modificáveis.",
  "Track": "Rastreamento",
  "Income": "Renda",
  "Expense": "Despesas",
  "Transfer": "Transferências",
  "transactionsAndManageAccounts": "transações e gerencie uma variedade de contas:",
  "checkings": "Conta corrente",
  "savings": "Poupança",
  "realEstate": "Imóveis",
  "stocks": "Mercados de ações",
  "bonds": "Títulos",
  "crypto": "Criptografia",
  "notes": "Notas, dinheiro Carteira",
  "envelopes": "Envelopes",
  "privateEquity": "Patrimônio privado",
  "metal": "Metal",
  "retirement": "Aposentadoria",
  "lifeInsurance": "Seguro de vida",
  "intellectualProperty": "Propriedade intelectual",
  "otherLiquidAsset": "Outros ativos líquidos",
  "otherFixedAsset": "Outro ativo fixo",
  "mortgage": "Hipoteca",
  "loan": "Empréstimo ao consumidor",
  "creditCard": "Cartão de crédito",
  "otherLiability": "Outros passivos",
  "AccountsManagement": "Gerenciamento de contas",
  "MultipleAccountsTypesAndGrouping": "Vários tipos e agrupamentos de contas",
  "LinkAccounts": "Vincular contas de suas instituições (disponível somente em alguns países)",
  "SmartAccounts": "Contas inteligentes",
  "AddEditDeleteTransactions": "Adicionar / Editar / Excluir transações",
  "TickVerifiedTransactions": "Marcar transações verificadas",
  "CategorizeTransactions": "Categorizar transações",
  "TagTransactions": "Marcar transações",
  "TrackKakeiboType": "Rastrear o tipo de Kakeibo",
  "TrackInvestments": "Rastrear investimentos (disponível somente em alguns países)",
  "ImportFromCSVFile": "Importar transações completas ou incrementais de um arquivo CSV",
  "ExportToCSVFile": "Exportar transações para um arquivo CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Plano de 8 etapas para a independência financeira, orçamento detalhado, alcance suas metas financeiras mais rapidamente.",
  "levelsTowardsFI": "8 níveis rumo à independência financeira",
  "EstablishBudgetsPer": "Estabelecer orçamentos por",
  "account": "conta",
  "accountType": "Tipo de conta",
  "KakeiboType": "Tipo de Kakeibo",
  "category": "categoria",
  "tag": "etiqueta",
  "label": "etiqueta",
  "TrackBudgetsPerFrequency": "Controle os orçamentos por frequência",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Criar metas sobre gastos, saldo, fluxo de caixa, ações",
  "TrackGoalsProgress": "Acompanhar o progresso das metas",
  "ReviewLearnOptimizeWithReportsCharts": "Analise, aprenda e otimize com relatórios, gráficos, tendências, percepções e ferramentas.",
  "Dashboard": "Painel de controle",
  "FSNetWorth": "Demonstrativos financeiros: Patrimônio líquido",
  "FSPnL": "Demonstrações financeiras: Declaração de renda/lucros e perdas",
  "FSBalanceSheetAssetsLiabilities": "Demonstrações financeiras: Balanço patrimonial, ativos, passivos",
  "FSCashFlow": "Demonstrações financeiras: Demonstração de fluxo de caixa, crédito de débito, fluxos",
  "FSFlows": "Demonstrações financeiras: Fluxos",
  "FSRatios": "Demonstrações financeiras: Índices",
  "TrendsMonthEnd": "Tendências de fim de mês: Receitas e despesas, fluxo de caixa",
  "TrendsPerformance": "Tendências de desempenho: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tendências de renda por",
  "SpendingTrendsPer": "Tendências de gastos por",
  "RecurringItemsIE": "Itens recorrentes: Receitas e despesas",
  "DebtProgressTrends": "Tendências de progresso da dívida",
  "KakeiboMTDReviewTrends": "Kakeibo: Revisão do MTD, último mês, tendências",
  "FIWCLE": "Independência financeira: Gráfico de parede, despesas por energia vitalícia",
  "DebtPaydownSnowballAvalanche": "Pagamento de dívidas: Bola de neve, Avalanche",
  "FullyCustomizableAnalyticsRange": "Intervalo de tempo de análise totalmente personalizável",
  "ContactUs": "Entre em contato conosco",
  "Privacy": "Privacidade e privacidade",
  "Terms": "Termos de uso",
  "About": "Sobre o site",
  "IAgreeToThe": "Eu concordo com os",
  "AndThe": "e com a",
  "PrivacyPolicy": "Política de Privacidade",
  "TermsOfUse": "Termos de uso",

  "DigitalSoftwareExperienceTagline": "Experiência de software digital para o mundo moderno",
  "DigitalExperience": "Experiência digital",
  "SoftwareForTheModernWorld": "Software para o mundo moderno",
  "MobileApplications": "Aplicativos móveis",
  "forConnectedAndOfflineHumans": "para pessoas conectadas e off-line",
  "CloudSaaS": "SaaS na nuvem",
  "ResponsiveAndWebServices": "Serviços responsivos e da Web",
  "PersonalFinanceServices": "Serviços de finanças pessoais",
  "YS_p1": "A Yesan é uma empresa de software dinâmica, especializada no desenvolvimento de aplicativos móveis de última geração adaptados aos consumidores. Com um profundo entendimento das necessidades e preferências em evolução dos usuários experientes em tecnologia de hoje, a Yesan se dedica a criar experiências móveis intuitivas, envolventes e ricas em recursos que enriquecem a vida de seus usuários.",
  "YS_p2": "No centro da missão da Yesan está um compromisso incansável com a inovação e a criatividade. Cada produto é meticulosamente criado para oferecer funcionalidade perfeita e uma experiência excepcional para o usuário.",
  "PersonalFinanceApplication": "Aplicativo de finanças pessoais",
  "YPF_p1": "O Yesan, Personal Finance é um aplicativo móvel de finanças pessoais de última geração, projetado para capacitar os usuários com ferramentas abrangentes de gerenciamento financeiro, convenientemente acessíveis na ponta dos dedos. Com uma interface elegante e intuitiva, o Yesan, Personal Finance oferece uma abordagem holística para o gerenciamento de finanças, atendendo a usuários de todos os níveis de conhecimento financeiro.",
  "YPF_p2": "Os principais recursos incluem controle de orçamento, categorização de despesas e monitoramento de transações em tempo real, permitindo que os usuários obtenham insights sobre seus hábitos de gastos sem esforço. O aplicativo também oferece opções de orçamento personalizáveis, permitindo que os usuários definam metas financeiras e acompanhem seu progresso ao longo do tempo.",
  "YPF_p3": "Além disso, o Yesan, Personal Finance prioriza a segurança, empregando protocolos de criptografia de última geração para proteger as informações financeiras confidenciais dos usuários. Com medidas de segurança de nível bancário, os usuários podem vincular suas contas com confiança e sincronizar transações sem comprometer a privacidade.",
  "YPF_p4": "O Yesan, Personal Finance vai além do orçamento básico, oferecendo análises criteriosas e recomendações personalizadas para otimizar as decisões financeiras. Seja para identificar possíveis oportunidades de economia, monitorar portfólios de investimento ou gerenciar estratégias de pagamento de dívidas, o aplicativo fornece insights personalizados para ajudar os usuários a atingir seus objetivos financeiros.",
  "Discover": "Descubra",
  "Firstname": "Nome",
  "Lastname": "Sobrenome",
  "Company":"Empresa",
  "Subject": "Assunto",
  "Email": "E-mail",
  "Message": "Mensagem",
  "ThankYouForContactingUs": "Obrigado por entrar em contato conosco",
  "ValidFirstnameRequired": "É necessário ter um nome válido.",
  "ValidLastnameRequired": "É necessário que o sobrenome seja válido.",
  "ValidEmailAddressRequired": "Digite um endereço de e-mail válido.",
  "ValidSubjectRequired": "Selecione um assunto válido.",
  "ValidMessageRequired": "Digite uma mensagem válida.",
  "UnableToSendTheFormPleaseRetryLater": "Não foi possível enviar o formulário, tente novamente mais tarde.",
  "Information": "Informações",
  "Sales":"Vendas",
  "Support": "Suporte",
  "Press": "Imprensa",
  "Partnership": "Parcerias",
  "Other": "Outros",
  "Blog": "Blog",

  "Accept":"Aceitar",
  "Decline":"Declínio",

  "WorklogCalendar":"Calendário do Worklog para o Jira",

  "DirectlyAccessibleInProjectApps":"Acessível diretamente nos aplicativos de projeto",
  "VisualizeWhereYouSpentYourTime":"Visualize onde você gastou seu tempo",
  "AllYourWorklogsInACalendar":"Todos os seus registros de trabalho em um calendário",
  "MonthSummary":"Resumo do mês",
  "CheckIfYouForgotToLogTime":"Verifique se você esqueceu de registrar o tempo.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Acesse diretamente os problemas e atualize o tempo",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Clique no item do registro de trabalho para acessar diretamente os problemas e editar o tempo registrado.",
  "AlsoAvailableInDarkMode":"Também disponível no modo escuro",
  "DirectlyLogWorkOnTheCalendarVisually":"Registre o trabalho diretamente no calendário visualmente",
  "ClickOnTheCalendarToCreateNewWorklog":"Clique no calendário para criar um novo registro de trabalho",

  "AppsForAtlassian":"Aplicativos para Atlassian",
  "YCL_p1":"Visualize todos os seus worklogs em um calendário com visualizações de mês, semana, semana de trabalho e dia.",
  "YCL_p2":"Registre o trabalho diretamente do calendário, selecionando visualmente o intervalo de tempo.",
  "YCL_p3":"Identifique se você esqueceu de registrar o tempo em suas planilhas de horas.",
  "YCL_p4":"Disponível em seu idioma: Inglês (Reino Unido), Inglês (EUA), Chinês (Simplificado), Chinês (Tradicional), Tcheco, Dinamarquês, Holandês, Estoniano, Finlandês, Francês, Alemão, Húngaro, Islandês, Italiano, Japonês, Coreano, Norueguês, Polonês, Português (Brasil), Português (Portugal), Russo, Espanhol, Sueco, Turco.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portfólio Financeiro para Jira",
  "BringRealFinancialPortfolio":"Leve a gestão real do portfólio financeiro para o Jira. Acompanhe orçamentos, CapEx/OpEx e custos de projetos em um único lugar.",
  "YFPAboutQ":"Quanto nossos projetos do Jira estão realmente nos custando?",
  "YFPAbout":"Portfólio Financeiro para Jira\nLíderes financeiros e PMOs têm dificuldade em responder a uma pergunta simples:\nQuanto nossos projetos do Jira estão realmente nos custando?\nO Jira acompanha o trabalho.\nO departamento financeiro acompanha os orçamentos.\nEste aplicativo finalmente conecta os dois.\n\nO Portfólio Financeiro transforma o Jira em uma plataforma leve de PPM + planejamento financeiro — sem a necessidade de ferramentas corporativas caras.",
  "YFPPorfolioQ":"Orçamentos e acompanhamento de portfólios",
  "YFPPorfolioP":"Crie portfólios em vários projetos do Jira e defina: valor do orçamento, moeda, intervalo de datas, projetos incluídos, equipes. Acompanhe os custos reais automaticamente à medida que o trabalho é realizado no Jira.",
  "YFPPorfolioListQ":"Portfólios",
  "YFPPorfolioListP":"Crie portfólios financeiros que combinam vários projetos do Jira e veja instantaneamente: Orçamento vs. custo real, taxa de queima do projeto em tempo real, detalhamento de CapEx vs. OpEx, custo por issue e projeto, relatórios financeiros exportáveis. Tudo alimentado diretamente pelos registros de trabalho do Jira.",
  "CostQ":"Cálculo automático de custos",
  "CostP":"Transforme o registro de tempo em dados financeiros reais. O aplicativo: lê registros de trabalho do Jira, aplica taxas horárias, calcula os custos reais do projeto diariamente. Sem planilhas. Sem trabalho manual.",
  "RatesQ":"Taxas",
  "RatesP":"Defina a taxa horária por projeto, equipe ou globalmente",
  "ReportQ":"Relatórios financeiros em CSV",
  "ReportP":"Exporte dados financeiros do portfólio em segundos. Perfeito para: equipes financeiras, relatórios para o CFO, planejamento orçamentário, suporte à auditoria",
  "SettingsQ":"Classificação CapEx vs OpEx",
  "SettingsP":"Atenda aos requisitos contábeis e de auditoria. Classifique o trabalho em: desenvolvimento capitalizável (CapEx), trabalho operacional (OpEx). Gere relatórios exportáveis prontos para as equipes financeiras."
};


export const documents = {
};
